<!--
  Header Component Template

  Displays the application header with:
  - Branding (logo and title)
  - User information and profile menu
  - Role badge

  Enhanced with ARIA labels and semantic HTML for accessibility.
-->

<header class="app-header" role="banner">
  <!-- Brand section -->
  <div class="brand-section">
    <img *ngIf="!languageService.isRTL()" class="brand-logo" src="assets/images/logo-dark.svg" alt="BlueRide Logo">
    <img *ngIf="languageService.isRTL()" class="brand-logo logo-ar-dark" src="assets/images/logo-ar.svg" alt="BlueRide Logo">
    <h1 class="brand-title">
      <span class="sr-only">BlueRide Companies</span>
      <span aria-hidden="true">{{ 'header.brandTitle' | translate }}</span>
    </h1>
  </div>

  <!-- View mode toggle (SuperAdmin only) -->
  <div class="view-mode-toggle">
    <p-selectButton
      [options]="viewModeOptions"
      [(ngModel)]="currentViewMode"
      (onChange)="onViewModeChange($event.value)"
      optionLabel="label"
      optionValue="value"
      [allowEmpty]="false"
      styleClass="view-mode-select">
      <ng-template pTemplate="item" let-item>
        <i [class]="item.icon" style="margin-inline-end: 0.375rem;"></i>
        <span class="view-mode-label">{{ item.label }}</span>
      </ng-template>
    </p-selectButton>
  </div>

  <!-- User section -->
  <div class="user-section" *ngIf="currentUser">
    <!-- Language switcher -->
    <div class="language-switcher" (click)="toggleLanguage()" role="button" [attr.aria-label]="'common.language' | translate">
      <span class="language-circle">{{ languageDisplay() }}</span>
    </div>

    <!-- User info and role badge -->
    <div class="user-info">
      <span class="user-name" id="current-user-name">{{ currentUser.name }}</span>
      <span [class]="getRoleBadgeClass()" role="status" [attr.aria-label]="'User role: ' + getRoleDisplayName()">
        {{ getRoleDisplayName() }}
      </span>
    </div>

    <!-- User avatar with menu -->
    <div class="user-avatar-wrapper">
      <button
        type="button"
        class="avatar-button"
        (click)="menu.toggle($event)"
        [attr.aria-label]="'User menu for ' + currentUser.name"
        [attr.aria-expanded]="menu.visible"
        aria-haspopup="true"
        aria-controls="user-menu">
        <p-avatar
          [label]="getUserInitials()"
          shape="circle"
          aria-hidden="true">
        </p-avatar>
      </button>
      <p-menu
        #menu
        [model]="userMenuItems"
        [popup]="true"
        [appendTo]="'body'"
        id="user-menu"
        role="menu"
        aria-labelledby="current-user-name">
      </p-menu>
    </div>
  </div>
</header>
